'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxForm = require('redux-form');

var _Notifications = require('ReduxMessenger/reducers/Notifications');

var _Notifications2 = _interopRequireDefault(_Notifications);

var _Auth = require('./Auth');

var _Auth2 = _interopRequireDefault(_Auth);

var _Create = require('./Create');

var _Create2 = _interopRequireDefault(_Create);

var _Checkout = require('./Checkout');

var _Checkout2 = _interopRequireDefault(_Checkout);

var _ExistingAccounts = require('./ExistingAccounts');

var _ExistingAccounts2 = _interopRequireDefault(_ExistingAccounts);

var _Invited = require('./Invited');

var _Invited2 = _interopRequireDefault(_Invited);

var _SalesPartner = require('./SalesPartner');

var _SalesPartner2 = _interopRequireDefault(_SalesPartner);

var _SalesPro = require('./SalesPro');

var _SalesPro2 = _interopRequireDefault(_SalesPro);

var _UserInfo = require('./UserInfo');

var _UserInfo2 = _interopRequireDefault(_UserInfo);

var _Utms = require('./Utms');

var _Utms2 = _interopRequireDefault(_Utms);

var _Hubs = require('./Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _TrialInfo = require('./TrialInfo');

var _TrialInfo2 = _interopRequireDefault(_TrialInfo);

var _Validation = require('./Validation');

var _Validation2 = _interopRequireDefault(_Validation);

var _Analytics = require('./Analytics');

var _Analytics2 = _interopRequireDefault(_Analytics);

var _VisitorContext = require('./VisitorContext');

var _VisitorContext2 = _interopRequireDefault(_VisitorContext);

var _MabCopy = require('./MabCopy');

var _MabCopy2 = _interopRequireDefault(_MabCopy);

var _OAuth = require('./OAuth');

var _OAuth2 = _interopRequireDefault(_OAuth);

var _Talon = require('./Talon');

var _Talon2 = _interopRequireDefault(_Talon);

var _CurrentStep = require('./CurrentStep');

var _CurrentStep2 = _interopRequireDefault(_CurrentStep);

var _RegisteredLeads = require('./RegisteredLeads');

var _RegisteredLeads2 = _interopRequireDefault(_RegisteredLeads);

var _ContactProperties = require('./ContactProperties');

var _ContactProperties2 = _interopRequireDefault(_ContactProperties);

var _Partner = require('./Partner');

var _Partner2 = _interopRequireDefault(_Partner);

var _EmailVerification = require('./EmailVerification');

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

var _DynamicSidebar = require('./DynamicSidebar');

var _DynamicSidebar2 = _interopRequireDefault(_DynamicSidebar);

var _Survey = require('./Survey');

var _Survey2 = _interopRequireDefault(_Survey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  router: _reactRouterRedux.routerReducer,
  notifications: _Notifications2.default,
  auth: _Auth2.default,
  create: _Create2.default,
  checkout: _Checkout2.default,
  existingAccounts: _ExistingAccounts2.default,
  form: _reduxForm.reducer,
  invited: _Invited2.default,
  salesPartner: _SalesPartner2.default,
  salesPro: _SalesPro2.default,
  userInfo: _UserInfo2.default,
  utms: _Utms2.default,
  hubs: _Hubs2.default,
  trialInfo: _TrialInfo2.default,
  validation: _Validation2.default,
  analytics: _Analytics2.default,
  visitorContext: _VisitorContext2.default,
  oauth: _OAuth2.default,
  mabCopy: _MabCopy2.default,
  talon: _Talon2.default,
  currentStep: _CurrentStep2.default,
  registeredLeads: _RegisteredLeads2.default,
  contactProperties: _ContactProperties2.default,
  partner: _Partner2.default,
  emailVerification: _EmailVerification2.default,
  dynamicSidebar: _DynamicSidebar2.default,
  survey: _Survey2.default
});
module.exports = exports['default'];